import Vue from 'vue'
import Vuex from 'vuex'
import state from './modules/state'
import facilities from './modules/facilities'
import bookingTypes from './modules/booking-types'
import profiles from './modules/profiles'
import bookings from './modules/bookings'
import profileTypes from './modules/profile-types'
import profileCategories from './modules/profile-categories'
import currencies from './modules/currencies'
import accounts from './modules/accounts'
import transactions from './modules/transactions'
import rooms from './modules/rooms'
import guestTypes from './modules/guest-types'
import guestCategories from './modules/guest-categories'
import guests from './modules/guests'
import uuids from './modules/uuids'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    state,
    facilities,
    bookingTypes,
    profiles,
    bookings,
    profileTypes,
    profileCategories,
    currencies,
    accounts,
    transactions,
    rooms,
    guestTypes,
    guestCategories,
    guests,
    uuids
  }
})
